export const selectAnsweredCall = (state) => [state.answeredCall, state.setAnsweredCall]
export const selectAnsweredCallOnly = (state) => state.answeredCall
export const selectRingingCall = (state) => [state.ringingCall, state.setRingingCall]
export const selectCallType = (state) => state.answeredCall?.interaction?.channel
export const selectHasAVIssues = (state) => [state.hasAVIssues, state.setHasAVIssues]
export const selectExpectingAnswer = (state) => [state.expectingAnswer, state.setExpectingAnswer]
export const selectDialHistory = (state) => [state.dialHistory, state.setDialHistory]
export const selectSetDialHistory = (state) => state.setDialHistory
